export enum LevelNodeType {
    CROP_UNLOCK,
    FIELD_UNLOCK,
    FREE_SPIN,
}
